import tracking from '@/helper/tracking';
import type { TrackingInformation } from '@/helper/tracking';
import type { TrackingViewItemInformation } from '@/helper/trackingUtils';
import { isEqual } from '@/helper/utils';
import { useEffect, useRef } from 'react';

type UserStore = {
  userTrackingData: TrackingInformation | undefined;
  setUserTrackingData: (data?: TrackingInformation) => void;
};

export function useViewItemTracking({
  userStore,
  trackingItem,
}: {
  userStore: UserStore;
  trackingItem: TrackingViewItemInformation | null | undefined;
}): void {
  const viewItemTracking = useRef(false);

  useEffect(() => {
    if (userStore?.userTrackingData) {
      if (!isEqual(trackingItem, userStore.userTrackingData)) {
        userStore.setUserTrackingData(trackingItem ?? undefined);
      }
      if (userStore.userTrackingData && !viewItemTracking.current && trackingItem && trackingItem.isStageCTA) {
        tracking.nonCommodityOrBenefitViewItem([userStore.userTrackingData]);
        viewItemTracking.current = true;
      }
    }
  }, [userStore, trackingItem]);
}
